export function hashAccount(account) {
    return `${account.blockchain}-${account.address}`;
}
